

export const formatPhoneNo = (pno: string | null | undefined): string => {
    if (pno) {
        return pno.replace(/\((\d{3})\)(\d{3})-(\d{3})/, '$1$2$3')
    } else {
        return ''
    }
}

export const formatPhoneNoInReadableForm = (pno: string | null | undefined, locale: string): string => {
    if (pno && (locale === 'en-us' || locale === 'en-ca')) {
        return pno.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
    } else {
        return pno;
    }
}

export const sanitizePhoneNo = (pno: string | null | undefined): string => {
    if (pno) {
        return pno.match(/\d+/g).join('')
    } else {
        return '';
    }

}